export const TASK_TAGS_STYLES_ID = "task-tags-styles"
